module.exports = __webpack_public_path__ + "img/horizontal_4_7_pp123_8017.e32e7441.png";